module.exports = __webpack_public_path__ + "img/icon-settings.1fafe628.svg";